import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function AdminPublicRoute({ children }) {
    const { user } = useSelector(state => state.auth)

    return user?.role === "student" ? children : <Navigate to="/admin/dashboard" />;
}
